import * as React from 'react';
import { Row, Col, Icon } from 'antd';
import { CenteredContent, MainLogo, RegisterWithBackground, RegisterContent } from './RegisterLayout.Style';
import { RegisterFooterLayout } from "../RegisterFooterLayout";
import { FooterLayout } from '../FooterLayout';
export interface Props {
    children?: React.ReactNode;
}

export interface State { }

export default class RegisterLayout extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <RegisterWithBackground className="react-transition fade-in" style={{ animationDuration: '750ms' }}>
                <CenteredContent>
                    <Row type="flex" align="middle" justify="center">
                        <Col style={{ backgroundColor: 'white' }}>
                            <RegisterContent>
                                {this.props.children}
                            </RegisterContent>
                        </Col>
                    </Row>

                </CenteredContent>
                <FooterLayout />
            </RegisterWithBackground>
        );
    }
}
